import { API_ENDPOINTS, apiService } from "../api";
import type { AccountProfileResponse, AccountProfileUpdate } from "./accountProfile.types";

export const fetchAccountProfile = (): Promise<AccountProfileResponse> =>
  apiService.getEnvelope<AccountProfileResponse>(API_ENDPOINTS.auth.me);

export const uploadAccountAvatar = async (file: File): Promise<AccountProfileResponse> => {
  const body = new FormData();
  body.append("file", file);
  const envelope = await apiService.postFormData<{ data: AccountProfileResponse }>(
    API_ENDPOINTS.auth.avatar,
    body,
  );
  return envelope.data;
};

export const removeAccountAvatar = async (): Promise<AccountProfileResponse> => {
  const envelope = await apiService.delete<{ data: AccountProfileResponse }>(API_ENDPOINTS.auth.avatar);
  return envelope.data;
};

export const updateAccountProfile = (
  update: AccountProfileUpdate,
): Promise<AccountProfileResponse> =>
  apiService.patchEnvelope<AccountProfileResponse>(API_ENDPOINTS.auth.me, update);
